/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".report-selection[_ngcontent-%COMP%]{display:flex;flex-direction:row;background-color:#f0f0f0;padding:.5rem;z-index:1}.report-selection[_ngcontent-%COMP%]   .grower[_ngcontent-%COMP%]{flex-grow:1}.report-selection[_ngcontent-%COMP%]   .grower[_ngcontent-%COMP%]   .mat-radio-button[_ngcontent-%COMP%]{margin-right:1rem}.report-selection[_ngcontent-%COMP%]   .mat-button[_ngcontent-%COMP%]{-ms-grid-row-align:center;align-self:center}.mat-button[_ngcontent-%COMP%]{width:125px}\n/*# sourceMappingURL=build-health.component.css.map*/"];
export { styles as styles };
